<form [formGroup]="RemoveResourceAssignform">

<div class="row" style="height: 70vh !important; overflow: auto;">
  <div class="col-8">

    <div class="col-12">
      <div class="row pt-3">
        <div class="col-3 text-right pr-0 pt-1">        
          <div class="d-flex  flex-row-reverse">
        <div class="p-0">Subject/Topic</div></div> </div>
        <div class="col-9 pl-2">
          <input type="text" [attr.disabled]="true"  formControlName="Subject_Name" (ngModelChange)="Editformvalidation()" class="form-control form-control-sm input-txt"/>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="row pt-2">
        <div class="col-3 text-right pr-0 pt-1">        
          <div class="d-flex  flex-row-reverse">
        <div class="p-0">Resource Name</div></div> </div>
        <div class="col-9 pl-2">
          <input type="text" [attr.disabled]="true" formControlName="PowerUserId" (ngModelChange)="Editformvalidation()" class="form-control form-control-sm input-txt" />
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="row pt-2">
        <div class="col-3 text-right pr-0 pt-1">        
          <div class="d-flex  flex-row-reverse">
        <div class="p-0">Start date</div></div> </div>
        <div class="col-9 pl-2">
          <input type="text" [readonly]="Disable" [attr.disabled]="true" formControlName="StartDate" [owlDateTime]="dt1" [owlDateTimeTrigger]="dt1"
          class="form-control form-control-sm input-txt" (ngModelChange)="Editformvalidation()" placeholder="Start date">
        <owl-date-time [disabled]="Disable" [pickerType]="'calendar'" #dt1></owl-date-time>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="row pt-2">
        <div class="col-3 text-right pr-0 pt-1">        
          <div class="d-flex  flex-row-reverse">
           <div class="p-0 label-red">*</div>
        <div class="p-0">End date</div></div> </div>
        <div class="col-9 pl-2">
          <input type="text" formControlName="EndDate" [owlDateTime]="dt2" [owlDateTimeTrigger]="dt2"
            class="form-control form-control-sm input-txt" (ngModelChange)="compareEndDates()">
          <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
        </div>
        <div class="col-3"></div>
        <div class="col-9"><label  class="Valid1" *ngIf="error.isError">{{ error.errorMessage }}</label></div>
        <div class="col-3"></div>
        <div class="col-9"><label  class="Valid1"  *ngIf="removesubmit && !RemoveResourceAssignform.value.EndDate">Please Select End Date</label></div>
      </div>
    </div>
    <div class="col-12 text-right">
      <div class="row pt-2">
        <div class="col-3 text-right pr-0 pt-1 pl-0">        
          <div class="d-flex flex-row-reverse">
        <div class="p-0">Termination comments</div></div> </div>
        <div class="col-9 pl-2">
          <textarea class="form-control input-txt1" formControlName="TerminationCommentText" (ngModelChange)="Editformvalidation()" maxlength="4000" id="txtAssignmentIntruction"></textarea>
          <label class="form-check-label maxlength1" for="exampleCheck1">Characters {{Descriptionvaluelength}}/{{DescriptionMaxlength}}</label>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="row pt-2">
        <div class="col-3 text-right pr-0 pt-1">        
          <div class="d-flex  flex-row-reverse">
        <div class="p-0">Delegated to</div></div> </div>
        <div class="col-9 pl-2">
          <select class="form-control form-control-sm input-txt" formControlName="DelegatedToPowerUserId">
          <option *ngFor="let s of getresourcedetails;let i=index" [value]="s.Power_User_ID">{{s.Full_Name}}</option>
        </select>
        </div>
    </div>
     
  </div>
  </div>
  <div class="col-4">
    <div class="row">
      <div class="col-12">
        <div class="d-flex">          
          <div class="p-0">Termination Reasons</div>
          <div class="p-0 label-red">*</div>
        </div>
      </div>
      <div class="col-12">
        <div class="row px-1 mx-1" *ngFor="let s of ResponseReason">
          <div class="col-12">
            <div class="form-check p-1" style="padding-top: 1px;">
              <input type="checkbox" [value]="s.Termination_Reason_Type_Code" formControlName="Termination_Reason_Selected_Ind" (change)="eventCheck1($event)" [checked]="s.Termination_Reason_Selected_Ind=='Y'"class="form-check-input chkbx-size p-0">
              <label class="form-check-label pt-1">{{s.Termination_Reason_Type_Name}}</label>
            </div>
          </div>
        </div>
        <div class="row pt-3">
          <div class="col-12"><label  class="Valid1" *ngIf="error1.isError">{{ error1.errorMessage }}</label></div>
        </div>
      </div>
    </div>
      
    
    
    
  </div>
  
</div>
  <div class="row p-1">
    <div class="col-12">
      <div class="d-flex">
        <div class="col-2"></div>
        <div class="px-1">
          <button type="button" [disabled]="!RemoveResourceAssignform.valid || !check" (click)="Save()" class="btn btn-sm bl-btn">Save</button>
        </div>
        <div class="px-1">      
          <button type="button" *ngIf="!RemoveResourceAssignform.valid || !check" (click)="cancel()" class="btn btn-sm bg-light border">Cancel</button>
          <button type="button" *ngIf="RemoveResourceAssignform.valid && check" (click)="RemoveResouceclosepop()" class="btn btn-sm bg-light border">Cancel</button>
        </div>
      </div>
    </div>
  </div>



</form>
